<!-- <img class="logo" [src]="asset('assets/images/ibk-logo.svg')" alt="Interbank logo" /> -->

<h2 *ngIf="internetBanking" class="title f-regular"><b class="f-bold">¡Tu cuenta est&aacute; operativa!</b></h2>
<h2 *ngIf="!internetBanking" class="title f-regular"><b class="f-bold">Felicidades, ¡Tu Cuenta Negocios est&aacute;
    lista!</b>
</h2>
<br /><br /><br />
<img class="logo" [src]="asset('assets/images/success-icon.svg')" alt="success icon" />
<!-- <h4 class="ibk-title ibk-title--blue title-success"><b class="f-bold">Tu cuenta negocio</b></h4>
<hr class="ibk-separator" />
<div class="ctn-business-account">
  <div class="ctn-pen-account">
    <span><b class="f-bold">Cuenta en soles</b></span>
    <br />
    <span>085-700181667-5</span>
    <span>CCI 000-308-570018166757-82</span>
    <br />
    <a href="#" class="ibk-link" (click)="evtCopy()"><span class="text-bold"><img class="img-copy"
          [src]="asset('assets/images/copy.svg')" alt="copy"> Copiar</span></a>
  </div>
  <div class="ctn-details">
    <a href="#" class="ibk-link icon-details" (click)="evtSeeDetail($event)"><span class="text-bold">Detalles</span></a>
  </div>
</div> -->
<img *ngIf="internetBanking" class="steps-natural-person" [src]="asset('assets/images/yes-internet-banking.svg')"
  alt="Steps of Natural person" />
<img *ngIf="!internetBanking" class="steps-natural-person" [src]="asset('assets/images/no-internet-banking.svg')"
  alt="Steps of Natural person" />
<br *ngIf="internetBanking" /><br *ngIf="internetBanking" /><br *ngIf="internetBanking" /><br *ngIf="internetBanking" />
<div class="ctn-access-app" *ngIf="internetBanking">
  <br />
  <h2 class="title f-regular"><b class="f-bold">¿C&oacute;mo accedo a mi App Empresas?</b></h2>
  <ol class="numbered-list">
    <li>Espera m&aacute;ximo 48 horas para recibir un correo con tus accesos.</li>
    <br />
    <li>Abre el documento adjunto que enviaremos, ingresando tu DNI y obt&eacute;n una contraseña temporal. Hazlo dentro
      de las
      24 horas porque la contraseña temporal expirar&aacute;.</li>
    <br />
    <li>Descarga el App Interbank Empresas desde <a
        href="https://play.google.com/store/apps/details?id=pe.interbank.bie&hl=es_PE&gl=US" class="ibk-link underlined"
        target="_blank"> Google Play </a> o <a href="https://apps.apple.com/pe/app/interbank-empresas/id1460901367"
        class="ibk-link underlined" target="_blank"> App Store </a> e
      ingresa.</li>
    <br />
    <li>Inicia sesi&oacute;n, usando tu DNI y la contraseña temporal, y activa tu <a
        href="https://www.youtube.com/watch?v=mftkGm7qc6U" class="ibk-link underlined" target="_blank"> token
        digital </a> para comenzar tus
      operaciones 100% online.</li>
    <br />
  </ol>

  <span class="f-regular text-center"><b class="f-bold">*¡Recuerda!</b> Con est&aacute;s mismas credenciales
    tambi&eacute;n
    puedes usar la Banca por Internet para Empresas desde la Web: www.interbank.pe</span>
</div>
<br *ngIf="internetBanking" />
<div class="ctn-business-app" *ngIf="internetBanking">
  <br />
  <h2 class="title f-regular color-blue"><b class="f-bold">¡Usa la App Empresas!</b></h2>
  <h3 class="f-regular"><b class="f-bold">Gestiona tu negocio desde tu celular de manera segura y sencilla.</b></h3>

  <div class="w-100">
    <div class="ctn-business-app-icon">
      <img class="" [src]="asset('assets/images/google-play.svg')" alt="Google Play" />
      <img class="" [src]="asset('assets/images/app-store.svg')" alt="App Store" />
    </div>
  </div>
  <br />
  <br />
  <a href="#" class="ibk-link underlined" (click)="evtCopy()"><span class="text-bold">¿Qu&eacute; puedo hacer desde la
      App?</span></a>
</div>
<br *ngIf="internetBanking" /><br *ngIf="internetBanking" /><br /><br *ngIf="internetBanking" />

<swiper [slidesPerView]="1" (slideChange)="onSlideChange()" [navigation]="true" [scrollbar]="{ draggable: true }"
  [centeredSlides]="true" [autoHeight]="true" class="ctn-swiper" *ngIf="internetBanking">
  <ng-template swiperSlide>
    <div class="ctn-slide">
      <h3 class="f-regular"><b class="f-bold">Banca por Internet para Empresas</b></h3>
      <span>Es una plataforma segura, &aacute;gil y f&aacute;cil para las operaciones de tu empresa.
        Permite consultar saldos, movimientos, estados de cuenta, entre otro.</span>
      <br />
      <br />
      <a href="#" class="ibk-link"><span class="text-bold">M&aacute;s informaci&oacute;n</span></a>
    </div>
  </ng-template>
  <ng-template swiperSlide>
    <div class="ctn-slide">
      <h3 class="f-regular"><b class="f-bold">Banca por Internet para Empresas</b></h3>
      <span>Es una plataforma segura, &aacute;gil y f&aacute;cil para las operaciones de tu empresa.
        Permite consultar saldos, movimientos, estados de cuenta, entre otro.</span>
      <br />
      <br />
      <a href="#" class="ibk-link"><span class="text-bold">M&aacute;s informaci&oacute;n</span></a>
    </div>
  </ng-template>
  <ng-template swiperSlide>
    <div class="ctn-slide">
      <h3 class="f-regular"><b class="f-bold">Banca por Internet para Empresas</b></h3>
      <span>Es una plataforma segura, &aacute;gil y f&aacute;cil para las operaciones de tu empresa.
        Permite consultar saldos, movimientos, estados de cuenta, entre otro.</span>
      <br />
      <br />
      <a href="#" class="ibk-link"><span class="text-bold">M&aacute;s informaci&oacute;n</span></a>
    </div>
  </ng-template>
</swiper>

<br *ngIf="internetBanking" /><br /><br /><br /><br /><br /><br /><br /><br />
<div class="ctn-doubts">
  <img class="img-interkbank" [src]="asset('assets/images/img-interbank.svg')" alt="img interbank" />
  <br />
  <h2 class="f-size-28 title f-regular color-white"><b class="f-bold">¿Tienes dudas?</b></h2>
  <h3 class="f-regular color-white"><b class="">Resu&eacute;lvelas en nuestro whatsapp 24/7</b></h3>

  <a href="#" class="ibk-link color-white d-flex" (click)="evtCopy()"><img
      [src]="asset('assets/images/icon-whatsapp.svg')" alt="icon whatsapp" /><span class="m-wsp">993 119001</span></a>
  <br /><br /><br />
  <span class="color-white d-flex"><span class="m-wsp">Escr&iacute;benos</span><img
      [src]="asset('assets/images/icon-next.svg')" alt="icon whatsapp" /></span>
</div>

<h2 class="f-size-28 title f-regular text-left"><b class="f-bold">Tambi&eacute;n puedes consultar desde nuestros atajos
    directos:</b></h2>
<div class="ba-field-group-view">
  <button class="ibk-btn collapsible">
    <span class="text title-size-large text-bold">¿C&oacute;mo obtengo la tarjeta de d&eacute;bito para mi
      empresa?</span>
  </button>
  <div class="ibk-description content">
    <p class="title-size-large text-justify">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
      acumulado S/28.39. Válido al
      28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
      monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
      tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
      la normativa vigente.</p>
  </div>
  <br *ngIf="internetBanking" />
  <button class="ibk-btn collapsible-next" *ngIf="internetBanking">
    <span class="text title-size-large text-bold">¿D&oacute;nde encuentro mi contraseña temporal?</span>
  </button>
  <div class="ibk-description content" *ngIf="internetBanking">
    <p class="title-size-large text-justify">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
      acumulado S/28.39. Válido al
      28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
      monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
      tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
      la normativa vigente.</p>
  </div>
  <br *ngIf="internetBanking" />
  <button class="ibk-btn collapsible-next" *ngIf="internetBanking">
    <span class="text title-size-large text-bold">¿Qu&eacute; hago si no me lleg&oacute; mi contraseña temporal?</span>
  </button>
  <div class="ibk-description content" *ngIf="internetBanking">
    <p class="title-size-large text-justify">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
      acumulado S/28.39. Válido al
      28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
      monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
      tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
      la normativa vigente.</p>
  </div>
  <br />
  <button class="ibk-btn collapsible-next">
    <span class="text title-size-large text-bold">¿Cu&aacute;l es el tarifario asociado a mi cuenta?</span>
  </button>
  <div class="ibk-description content">
    <p class="title-size-large text-justify">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
      acumulado S/28.39. Válido al
      28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
      monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
      tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
      la normativa vigente.</p>
  </div>
  <br />
  <button class="ibk-btn collapsible-next" *ngIf="internetBanking">
    <span class="text title-size-large text-bold">¿C&oacute;mo activo mi Token digital?</span>
  </button>
  <div class="ibk-description content" *ngIf="internetBanking">
    <p class="title-size-large text-justify">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
      acumulado S/28.39. Válido al
      28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
      monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
      tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
      la normativa vigente.</p>
  </div>
  <br *ngIf="internetBanking" />
  <button class="ibk-btn collapsible-next" *ngIf="internetBanking">
    <span class="text title-size-large text-bold">¿Qu&eacute; hago si olvido mi contraseña?</span>
  </button>
  <div class="ibk-description content" *ngIf="internetBanking">
    <p class="title-size-large text-justify">TREA mínima en soles de 1.4% a 365 días. Monto mínimo 2,000. Interés
      acumulado S/28.39. Válido al
      28/02/18. ITF 0.005%. Fondo de Seguro de Depósito (FSD) Diciembre 2017-Febrero 2018: S/97,529.00. El
      monto de cobertura del FSD actualizado, tasas de interés, comisiones, gastos y penalidades en el
      tarifario, en TiendasInterbank o en <span class="text-primary">www.interbank.pe,</span> conforme a
      la normativa vigente.</p>
  </div>
</div>
<!-- <ul class="check-list">
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content"> Tu cuenta está lista y 100% operativa. </span>
  </li>
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content"> Te hemos enviado la constancia y el detalle de tu cuenta a tu correo. </span>
  </li>
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content">
      Si necesitas tu tarjeta de débito en físico, acércate con tu DNI a tu tienda Interbank más cercana y solicítala.
    </span>
  </li>
</ul>

<img class="steps-natural-person" [src]="asset('assets/images/steps-natural-person.svg')"
  alt="Steps of Natural person" /> -->

<ibk-button class="ba-action">
  <button class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn" (click)="done()">Entendido</button>
</ibk-button>